import { PORTALS_CLS, PANWDS_TW2_CLS, PANWDS_TW3_CLS, CONTAINER_ADD_TW2_MATCHES, HEADLESSUI_PORTAL_ROOT } from './panwds-constants'
import type { ReactNode, ReactElement, ReactPortal } from 'react'

const patchReactDOM = (ReactDOM: any) => {
  const bodyEl = document.body as any
  if (!bodyEl._sparky_portals_tw2) {
    const _sparky_portals_tw2 = Object.assign(document.createElement(PORTALS_CLS), {
      className: PANWDS_TW2_CLS,
    })
    bodyEl.appendChild(_sparky_portals_tw2)
    bodyEl._sparky_portals_tw2 = _sparky_portals_tw2
  }
  if (!bodyEl._sparky_portals_tw3) {
    const _sparky_portals_tw3 = Object.assign(document.createElement(PORTALS_CLS), {
      className: PANWDS_TW3_CLS,
    })
    bodyEl.appendChild(_sparky_portals_tw3)
    bodyEl._sparky_portals_tw3 = _sparky_portals_tw3
  }

  const { createPortal } = ReactDOM
  const patchedCreatePortal = (children: ReactNode, container: Element, key?: null | string): ReactPortal => {
    const props = (children as ReactElement)?.props
    const className = props?.className || props?.addClassName
    if (container === document.body) {
      container = className?.includes(PANWDS_TW3_CLS) ? bodyEl._sparky_portals_tw3 : bodyEl._sparky_portals_tw2
    }
    else if ((container.parentNode as HTMLElement)?.id === HEADLESSUI_PORTAL_ROOT) {
      container.classList.add(PANWDS_TW3_CLS)
      container.classList.remove(PANWDS_TW2_CLS)
    }
    else if (!container.matches(CONTAINER_ADD_TW2_MATCHES) && !className?.includes(PANWDS_TW3_CLS)) {
      container.classList.add(PANWDS_TW2_CLS)
    }
    return createPortal(children, container, key)
  }
  Object.defineProperties(ReactDOM, {
    createPortal: { value: patchedCreatePortal }
  })
}

export default patchReactDOM
